import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { BedDouble, ShowerHead, Droplets, Car } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const fade = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
function AreaStat({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <motion.div variants={fade} className="text-center" data-id="element-160">
      <p className="text-[0.7rem] md:text-sm tracking-widest font-light text-text-muted" data-id="element-161">
        {label}
      </p>
      <p className="mt-2 md:mt-4 text-4xl md:text-6xl font-light text-primary leading-none" data-id="element-162">
        {value}
        <span className="align-super text-sm md:text-2xl ml-0.5 md:ml-1 font-light text-text-muted" data-id="element-163">
          m²
        </span>
      </p>
    </motion.div>;
}
function CountStat({
  label,
  value,
  icon: Icon
}: {
  label: string;
  value: string;
  icon: ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
}) {
  return <motion.div variants={fade} className="text-center flex flex-col items-center" data-id="element-164">
      <p className="text-[0.7rem] md:text-sm tracking-widest font-light text-text-muted" data-id="element-165">
        {label}
      </p>
      <div className="mt-2 md:mt-4 flex items-center justify-center gap-2 md:gap-3" data-id="element-166">
        <Icon className="w-6 h-6 md:w-8 md:h-8 text-accent" strokeWidth={1} data-id="element-167" />
        <span className="text-3xl md:text-5xl font-light text-primary" data-id="element-168">
          {value}
        </span>
      </div>
    </motion.div>;
}
export function StatsSection() {
  return <section className="w-full bg-bg-warm py-14 md:py-20 px-6 md:px-14 relative z-10" data-id="element-169">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={container} className="max-w-5xl mx-auto space-y-10 md:space-y-12" data-id="element-170">
        {/* Card 1: areas */}
        <div className="grid grid-cols-3 gap-4 sm:gap-6" data-id="element-171">
          <AreaStat label="Floor Area" value="610" data-id="element-172" />
          <AreaStat label="Lot Area" value="475" data-id="element-173" />
          <AreaStat label="Garden" value="190" data-id="element-174" />
        </div>

        <div className="w-full h-px bg-black/5" data-id="element-175" />

        {/* Card 2: counts */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 md:gap-6" data-id="element-176">
          <CountStat label="Bedrooms" value="5" icon={BedDouble} data-id="element-177" />
          <CountStat label="Baths" value="5" icon={ShowerHead} data-id="element-178" />
          <CountStat label="Powder Room" value="1" icon={Droplets} data-id="element-179" />
          <CountStat label="Car Park" value="4" icon={Car} data-id="element-180" />
        </div>
      </motion.div>
    </section>;
}